export default __webpack_public_path__ + "static/media/landChest2.f57e5467.svg";